import { getLocalAccessToken } from "../../utils/helper";
import api, { handleErrorCreateAndUpdate } from "../../services/api";
import { Notify, Toast } from "../../components/notify/Notify";
import { url } from "../../constants/path";
const accessToken = getLocalAccessToken();

api.defaults.headers.common["Authorization"] = "Bearer " + accessToken;

const URL = url.systemEmployee;

export const getEmployees = (params = {}, callback) => {
  api
    .get(URL, { params })
    .then((response) => {
      callback(response.data.data);
    })
    .catch((err) => Toast("warning", err.response.data.message));
};

export const getDetailEmployee = (id, callback) => {
  api
    .get(`${URL}/${id}`)
    .then((response) => callback(response.data.data))
    .catch((err) => Toast("warning", err.response.data.message));
};

export const createEmployee = (data, callback) => {
  api
    .post(URL, data)
    .then((response) => {
      getDetailEmployee(response.data.data.id, (result) => {
        callback(result);
        Toast("success", "Thành công");
      });
    })
    .catch((err) => {
      // callback(err);
      handleErrorCreateAndUpdate(err, callback);
    });
};

export const removeEmployee = (id) => {
  api
    .delete(`${URL}/${id}`)
    .then((response) => Toast("success", "Thành công"))
    .catch((err) => {
      Notify("warning", err.response.data.message);
    });
};

export const updateEmployee = (id, data, callback) => {
  api
    .patch(`${URL}/${id}`, data)
    .then((response) => {
      callback(response.data.data);
      Toast("success", "Thành công");
    })
    .catch((err) => {
      // callback(err);
      handleErrorCreateAndUpdate(err, callback);
    });
};

export const moveRole = (data, callback) => {
  api
    .patch(`${URL}/move-role`, data)
    .then((response) => {
      callback();
    })
    .catch((err) => {
      Notify("warning", err.response.data.message);
    });
};

export const moveDepartment = (data, callback) => {
  api
    .patch(`${URL}/move-room`, data)
    .then((response) => {
      callback();
    })
    .catch((err) => {
      Notify("warning", err.response.data.message);
    });
};

export const resetPassword = (data) => {
  api
    .patch(`${URL}/reset-pass`, data)
    .then((response) => {
      Toast("success", "Thành công");
    })
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};
